var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-filter-collection',_vm._b({attrs:{"available-filters":_vm.computedFilters,"apply-label":_vm.$t('global.actions.apply_filter')}},'t-filter-collection',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }